/**
 * Select della pagina: il `<select>` nativo dentro il riquadro `.nselect` del design
 * system, che porta bordo, freccia e focus. Nativo per tastiera e lettori di schermo.
 * @param {Object} props - Proprietà
 * @param {string} props.id - Id del select (per la `<label htmlFor>`)
 * @param {string|number} props.value - Valore corrente
 * @param {(valore: string) => void} props.onChange - Nuovo valore
 * @param {boolean} [props.disabled] - Non modificabile
 * @param {'md'|'sm'} [props.size] - Altezza
 * @param {import('react').ReactNode} props.children - Le `<option>`
 * @returns {import('react').JSX.Element}
 */
export const Select = ({
  id,
  value,
  onChange,
  disabled = false,
  size = 'md',
  'aria-label': ariaLabel,
  children
}) => (
  <span
    className={[
      'nselect',
      'cn-select',
      size === 'sm' ? 'cn-select--sm' : '',
      disabled ? 'is-disabled' : ''
    ]
      .filter(Boolean)
      .join(' ')}
  >
    <select
      id={id}
      value={value}
      disabled={disabled}
      aria-label={ariaLabel}
      onChange={(e) => onChange(e.target.value)}
    >
      {children}
    </select>
  </span>
)

export default Select
